(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8200],{

/***/ 44343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "capitalize": function() { return /* reexport */ capitalize/* default */.Z; },
  "createChainedFunction": function() { return /* reexport */ createChainedFunction/* default */.Z; },
  "createSvgIcon": function() { return /* reexport */ createSvgIcon/* default */.Z; },
  "debounce": function() { return /* reexport */ debounce/* default */.Z; },
  "deprecatedPropType": function() { return /* reexport */ deprecatedPropType; },
  "isMuiElement": function() { return /* reexport */ isMuiElement/* default */.Z; },
  "ownerDocument": function() { return /* reexport */ ownerDocument/* default */.Z; },
  "ownerWindow": function() { return /* reexport */ ownerWindow/* default */.Z; },
  "requirePropFactory": function() { return /* reexport */ requirePropFactory; },
  "setRef": function() { return /* reexport */ setRef/* default */.Z; },
  "unstable_useId": function() { return /* reexport */ unstable_useId/* default */.Z; },
  "unsupportedProp": function() { return /* reexport */ unsupportedProp; },
  "useControlled": function() { return /* reexport */ useControlled/* default */.Z; },
  "useEventCallback": function() { return /* reexport */ useEventCallback/* default */.Z; },
  "useForkRef": function() { return /* reexport */ useForkRef/* default */.Z; },
  "useIsFocusVisible": function() { return /* reexport */ useIsFocusVisible/* default */.Z; }
});

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/capitalize.js
var capitalize = __webpack_require__(93871);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/createChainedFunction.js
var createChainedFunction = __webpack_require__(82568);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/createSvgIcon.js + 1 modules
var createSvgIcon = __webpack_require__(594);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/debounce.js
var debounce = __webpack_require__(79437);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/utils/deprecatedPropType.js
function deprecatedPropType(validator, reason) {
  if (true) {
    return function () {
      return null;
    };
  }

  return function (props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (typeof props[propName] !== 'undefined') {
      return new Error("The ".concat(location, " `").concat(propFullNameSafe, "` of ") + "`".concat(componentNameSafe, "` is deprecated. ").concat(reason));
    }

    return null;
  };
}
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/isMuiElement.js
var isMuiElement = __webpack_require__(83711);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/ownerDocument.js
var ownerDocument = __webpack_require__(30626);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/ownerWindow.js
var ownerWindow = __webpack_require__(80713);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/utils/requirePropFactory.js
function requirePropFactory(componentNameInError) {
  if (true) {
    return function () {
      return null;
    };
  }

  var requireProp = function requireProp(requiredProp) {
    return function (props, propName, componentName, location, propFullName) {
      var propFullNameSafe = propFullName || propName;

      if (typeof props[propName] !== 'undefined' && !props[requiredProp]) {
        return new Error("The prop `".concat(propFullNameSafe, "` of ") + "`".concat(componentNameInError, "` must be used on `").concat(requiredProp, "`."));
      }

      return null;
    };
  };

  return requireProp;
}
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/setRef.js
var setRef = __webpack_require__(34236);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/utils/unsupportedProp.js
function unsupportedProp(props, propName, componentName, location, propFullName) {
  if (true) {
    return null;
  }

  var propFullNameSafe = propFullName || propName;

  if (typeof props[propName] !== 'undefined') {
    return new Error("The prop `".concat(propFullNameSafe, "` is not supported. Please remove it."));
  }

  return null;
}
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useControlled.js
var useControlled = __webpack_require__(22775);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useEventCallback.js
var useEventCallback = __webpack_require__(55192);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useForkRef.js
var useForkRef = __webpack_require__(17294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/unstable_useId.js
var unstable_useId = __webpack_require__(95001);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useIsFocusVisible.js
var useIsFocusVisible = __webpack_require__(24896);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/utils/index.js













 // eslint-disable-next-line camelcase




/***/ }),

/***/ 62810:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckBox');

exports.Z = _default;

/***/ }),

/***/ 43819:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(594);


/* harmony default export */ __webpack_exports__["Z"] = ((0,_utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), 'CheckBoxOutlineBlankOutlined'));

/***/ }),

/***/ 2108:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "default", ({
  enumerable: true,
  get: function get() {
    return _utils.createSvgIcon;
  }
}));

var _utils = __webpack_require__(44343);

/***/ }),

/***/ 31353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports seoKeys, emptySeo */
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2962);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




var seoKeys = {// NotFound: "notFound",
  // Homepage: "homePage",
  // firstHand: `firstHand_`, // use with car id. example: {firstHand_122123}
  // zeroKm: "zeroKm_", // use with car slug. example: {zeroKm_14/629/271/2021}
  // leasing: "leasing_", // use with car slug. example: {leasing_14/629/271/2021}
};

for (var key in seoKeys) {
  seoKeys[key] = encodeURIComponent(seoKeys[key].replace(/\/\[.+/, "").replace("/", "").replace(/-/g, " "));
}

var emptySeo = {
  title: " ",
  description: "",
  keywords: ""
};

var SeoMetaData = function SeoMetaData(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: data && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_0__/* .NextSeo */ .PB, {
      title: data.title,
      description: data.description || "",
      additionalMetaTags: [{
        name: "title",
        content: data.title
      }, {
        name: "keywords",
        content: data.keywords
      }, {
        name: "description",
        content: data.description
      }],
      openGraph: {
        title: data.title,
        description: data.description || ""
      }
    })
  });
};

/* harmony default export */ __webpack_exports__["ZP"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(SeoMetaData));

/***/ }),

/***/ 10201:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ otp; }
});

// EXTERNAL MODULE: ./common/SeoMetaData.tsx
var SeoMetaData = __webpack_require__(31353);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./api/index.ts + 2 modules
var api = __webpack_require__(91315);
// EXTERNAL MODULE: ./components/OtpStep/OtpPage.tsx + 2 modules
var OtpPage = __webpack_require__(80865);
// EXTERNAL MODULE: ./components/PurchasePage/GroupPurchasesContext.tsx
var GroupPurchasesContext = __webpack_require__(28218);
// EXTERNAL MODULE: ./components/PurchasePage/Preview/Payment/PaymentContext.tsx
var PaymentContext = __webpack_require__(79625);
// EXTERNAL MODULE: ./components/PurchasePage/PurchaseContext.tsx
var PurchaseContext = __webpack_require__(33574);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/pages/groupPurchases/payment.tsx + 1 modules
var payment = __webpack_require__(22505);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/GroupPurchases/OtpGroupPurchasesPage.tsx




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var OtpGroupPurchasesPage = function OtpGroupPurchasesPage() {
  var router = (0,next_router.useRouter)();

  var _useGroupPurchasesCon = (0,GroupPurchasesContext/* useGroupPurchasesContext */.ZA)(),
      groupPurchasesData = _useGroupPurchasesCon.groupPurchasesData,
      setGroupPurchasesSteps = _useGroupPurchasesCon.setGroupPurchasesSteps,
      setGroupPurchasesData = _useGroupPurchasesCon.setGroupPurchasesData,
      setIsAdmin = _useGroupPurchasesCon.setIsAdmin;

  var _usePurchaseContext = (0,PurchaseContext/* usePurchaseContext */.AX)(),
      setGroupPurchaseData = _usePurchaseContext.setGroupPurchaseData,
      groupPurchaseGuid = _usePurchaseContext.groupPurchaseGuid,
      setGroupPurchaseUserGuid = _usePurchaseContext.setGroupPurchaseUserGuid;

  var _usePaymentContext = (0,PaymentContext/* usePaymentContext */.JL)(),
      setPaymentSteps = _usePaymentContext.setPaymentSteps;

  (0,react.useEffect)(function () {
    setGroupPurchasesSteps(GroupPurchasesContext/* GroupPurchasesSteps.LeaderDetails */.NT.LeaderDetails);
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(OtpPage/* default */.Z, {
    type: "groupPurchases",
    editLink: "/groupPurchases",
    submit: /*#__PURE__*/function () {
      var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(success) {
        var addGroupPurchaseUser, _addGroupPurchaseUser, _addGroupPurchaseUser2, _getGroupPurchase$dat, getGroupPurchase, createGroupPurchesResponse, _createGroupPurchesRe, _createGroupPurchesRe2;

        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!success) {
                  _context.next = 37;
                  break;
                }

                _context.prev = 1;

                if (!groupPurchaseGuid) {
                  _context.next = 23;
                  break;
                }

                _context.next = 5;
                return (0,api.postGroupPurchaseAddGroupPurchaseUser)(_objectSpread(_objectSpread({}, groupPurchasesData), {}, {
                  groupPurchaseGuid: groupPurchaseGuid
                }));

              case 5:
                addGroupPurchaseUser = _context.sent;

                if (!addGroupPurchaseUser) {
                  _context.next = 21;
                  break;
                }

                setGroupPurchaseUserGuid(addGroupPurchaseUser === null || addGroupPurchaseUser === void 0 ? void 0 : (_addGroupPurchaseUser = addGroupPurchaseUser.data) === null || _addGroupPurchaseUser === void 0 ? void 0 : (_addGroupPurchaseUser2 = _addGroupPurchaseUser.body) === null || _addGroupPurchaseUser2 === void 0 ? void 0 : _addGroupPurchaseUser2.groupPurchaseUserGuid);
                _context.prev = 8;
                _context.next = 11;
                return (0,api.postGroupPurchaseGetGroupPurchase)({
                  groupPurchaseGuid: groupPurchaseGuid
                });

              case 11:
                getGroupPurchase = _context.sent;
                getGroupPurchase && setGroupPurchaseData(getGroupPurchase === null || getGroupPurchase === void 0 ? void 0 : (_getGroupPurchase$dat = getGroupPurchase.data) === null || _getGroupPurchase$dat === void 0 ? void 0 : _getGroupPurchase$dat.body);
                setGroupPurchasesSteps(GroupPurchasesContext/* GroupPurchasesSteps.LOADER */.NT.LOADER);
                getGroupPurchase && router.push("/groupPurchases/payment");
                setPaymentSteps(payment.PaymentSteps.PAYMENT);
                _context.next = 21;
                break;

              case 18:
                _context.prev = 18;
                _context.t0 = _context["catch"](8);
                console.log(_context.t0);

              case 21:
                _context.next = 32;
                break;

              case 23:
                _context.next = 25;
                return (0,api.postGroupPurchaseCreateGroupPurchase)(groupPurchasesData);

              case 25:
                createGroupPurchesResponse = _context.sent;

                if (createGroupPurchesResponse) {
                  setGroupPurchaseUserGuid(createGroupPurchesResponse.data.body.groupPurchaseUserGuid);
                  setGroupPurchasesData(_objectSpread(_objectSpread({}, groupPurchasesData), {}, {
                    //@ts-ignore
                    guid: createGroupPurchesResponse === null || createGroupPurchesResponse === void 0 ? void 0 : (_createGroupPurchesRe = createGroupPurchesResponse.data) === null || _createGroupPurchesRe === void 0 ? void 0 : (_createGroupPurchesRe2 = _createGroupPurchesRe.body) === null || _createGroupPurchesRe2 === void 0 ? void 0 : _createGroupPurchesRe2.groupPurchaseGuid
                  }));
                }

                groupPurchasesData && setGroupPurchaseData(groupPurchasesData);
                setIsAdmin(true);
                setGroupPurchasesSteps(GroupPurchasesContext/* GroupPurchasesSteps.LOADER */.NT.LOADER);
                router.push("/groupPurchases/payment");
                setPaymentSteps(payment.PaymentSteps.PAYMENT);

              case 32:
                _context.next = 37;
                break;

              case 34:
                _context.prev = 34;
                _context.t1 = _context["catch"](1);
                console.log(_context.t1);

              case 37:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 34], [8, 18]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()
  });
};

/* harmony default export */ var GroupPurchases_OtpGroupPurchasesPage = (OtpGroupPurchasesPage);
// EXTERNAL MODULE: ./components/PurchasePage/Preview/Payment/FailedPage.tsx
var FailedPage = __webpack_require__(69045);
// EXTERNAL MODULE: ./components/Reusable/Loader.tsx
var Loader = __webpack_require__(83457);
;// CONCATENATED MODULE: ./src/pages/groupPurchases/otp.tsx









var Otp = function Otp() {
  var _useGroupPurchasesCon = (0,GroupPurchasesContext/* useGroupPurchasesContext */.ZA)(),
      groupPurchasesSteps = _useGroupPurchasesCon.groupPurchasesSteps;

  var seo = {
    title: "הזדהות באמצעות קוד אימות - קוד אימות גיפטקארד",
    description: "הזדהות באמצעות קוד אימות - קוד אימות גיפטקארד",
    keywords: "הזדהות, קוד, OTP, קוד אימות"
  };
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SeoMetaData/* default */.ZP, {
      data: seo
    }), groupPurchasesSteps === GroupPurchasesContext/* GroupPurchasesSteps.FAIL */.NT.FAIL ? /*#__PURE__*/(0,jsx_runtime.jsx)(FailedPage/* default */.Z, {
      title: "\u05D0\u05D5\u05E4\u05E1\u05D9, \u05DE\u05E9\u05D4\u05D5 \u05D4\u05E9\u05EA\u05D1\u05E9 \u05D1\u05D3\u05E8\u05DA",
      text: "\u05D4\u05E2\u05DE\u05D5\u05D3 \u05E9\u05D7\u05D9\u05E4\u05E9\u05EA \u05DC\u05D0 \u05E7\u05D9\u05D9\u05DD \u05D0\u05D5 \u05E9\u05D9\u05E9 \u05DB\u05E8\u05D2\u05E2 \u05D1\u05E2\u05D9\u05D4 \u05D6\u05DE\u05E0\u05D9\u05EA \u05DC\u05D4\u05D2\u05D9\u05E2 \u05D0\u05DC\u05D9\u05D5",
      link: "/groupPurchases"
    }) : groupPurchasesSteps === GroupPurchasesContext/* GroupPurchasesSteps.LOADER */.NT.LOADER ? /*#__PURE__*/(0,jsx_runtime.jsx)(Loader/* default */.Z, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)(GroupPurchases_OtpGroupPurchasesPage, {})]
  });
};

/* harmony default export */ var otp = (Otp);

/***/ }),

/***/ 77381:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/groupPurchases/otp",
      function () {
        return __webpack_require__(10201);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 75263:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _typeof = (__webpack_require__(18698)["default"]);
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 18698:
/***/ (function(module) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4885,2726,3450,2198,2663,3818,7072,3588,4055,1456,9904,8643,2563,7870,865,8931,2505,9774,2888,179], function() { return __webpack_exec__(77381); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);